import { StyleSheet } from 'aphrodite';
import { header, titles } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	sendATestButton: {
		':hover': {
			color: titles,
		},
		':disabled': {
			cursor: 'default',
			opacity: 0.5,
		},
		alignItems: 'center',
		color: header,
		display: 'flex',
		fontSize: 14,
		minHeight: 21,
		minWidth: 106,
		position: 'relative',
		...CssSelectors.allChildren(
			{
				marginRight: 8,
			},
			'svg'
		),
	},
});
